export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: 'Who is this masterclass for?',
    answer: 'Anyone who wants to build something — a product, a business, a side project — and wants to use AI to do it faster and smarter. No technical background required. If you have an idea and curiosity, you\'re ready.',
  },
  {
    question: 'How long is it?',
    answer: 'The masterclass is 90 minutes. We cover a lot of ground, but it\'s designed to be focused and actionable — not a firehose. You\'ll leave with clear next steps, not just inspiration.',
  },
  {
    question: 'Is it live or recorded?',
    answer: 'We run live sessions so you can ask questions and engage in real time. Registered attendees also get access to the recording afterwards.',
  },
  {
    question: 'What tech or tools do I need?',
    answer: 'Just a laptop and an internet connection. We\'ll show you the tools live during the session. Most of what we use has a free tier.',
  },
  {
    question: 'How is this different from YouTube tutorials?',
    answer: 'YouTube gives you fragments. This masterclass gives you a framework — a way of thinking about AI that applies to anything you want to build. You\'ll leave with a mental model, not just a list of tools.',
  },
  {
    question: 'Do I need to have an idea already?',
    answer: 'It helps, but no. Part of the session is helping you identify what\'s worth building with AI and what\'s not. Many attendees come in with a vague idea and leave with a concrete plan.',
  },
  {
    question: 'When is the next session?',
    answer: 'Register your interest and we\'ll send you the next available date. Spots are limited to keep the session interactive.',
  },
];
